import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

import App from "./App";


const Launcher = () => {

	return (
		<Router>
			<Switch>
				<Route path="/" exact component={App} />
			</Switch>
		</ Router>

	);

};



export default Launcher;
